import { useState } from "react";
import TextField from "@material-ui/core/TextField";
import { Tooltip, Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { ToastMessage } from "../../../global/ToastMessage";
import { useDispatch } from "react-redux";
import { altaCatalogCiudadAction } from "./../../../ducks/catalogoCiudadDuck";
import BackDrop from "./../../../global/BackDrop";
import { AutoInputStyle } from "./styles";

const AltaCiudad = (props) => {
  const { CodigoPais = "0", NombrePais = "" } = props;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [nombre, setNombre] = useState("");
  const [isLoad, setIsload] = useState(false);
  const classes = AutoInputStyle();
  const handleClickOpen = () => {
    setOpen(true);
    LimpiarForm();
  };
  const handleClose = () => {
    setOpen(false);
    LimpiarForm();
  };
  const onGuardar = () => {
    if (CodigoPais !== "0") {
      setIsload(true);
      let payload = {
        Nombre: nombre,
        CodigoPais: CodigoPais,
      };
      dispatch(altaCatalogCiudadAction(payload)).then((Response) => {
        switch (Response.status) {
          case 500:
            ToastMessage.fire({
              icon: "error",
              title: "Ha habido un problema de conexión con el servidor",
            });
            break;
          case 400:
            ToastMessage.fire({
              icon: "warning",
              title: "<strong>Atención</strong>",
              text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
            });
            break;
          default:
            LimpiarForm();
            setIsload(false);
            setOpen(false);
            ToastMessage.fire({
              icon: "success",
              title: "Ingreso Correcto",
            });
            break;
        }
      });
    }
  };
  const LimpiarForm = () => {
    setNombre("");
  };
  return (
    <div>
      <Tooltip title="Agregar Ciudad">
        <span>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClickOpen}
            disabled={CodigoPais !== "0" ? false : true}
            style={{
                margin: "5px",
              }}
          >
            <AddCircleOutlineIcon />
          </Button>
        </span>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Agregar ciudad</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Pais: {NombrePais}
          </DialogContentText>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                required
                id="input-Nombre"
                label="Nombre"
                type="text"
                variant="outlined"
                name="nombre"
                value={nombre}
                onChange={(event) => {
                  setNombre(event.target.value);
                }}
                className={classes.textField}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={onGuardar}
            color="primary"
            disabled={CodigoPais !== "0" ? false : true}
          >
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
      <BackDrop open={isLoad} />
    </div>
  );
};
export default AltaCiudad;
